var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16007",
    "data-name": "Group 16007",
    transform: "translate(-761 -180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4627",
    "data-name": "Rectangle 4627",
    width: 25,
    height: 25,
    transform: "translate(761 180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15995",
    "data-name": "Group 15995",
    transform: "translate(-70.185 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15976",
    "data-name": "Group 15976",
    transform: "translate(834.115 148.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1597",
    "data-name": "Ellipse 1597",
    transform: "translate(0 0)",
    fill: "#4879f9",
    stroke: "#4879f9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.462,
    cy: 5.462,
    r: 5.462,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.462,
    cy: 5.462,
    r: 4.962,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_13901",
    "data-name": "Path 13901",
    transform: "translate(8.74 3.277)",
    fill: "#4879f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.462395668029785 10.42479610443115 C 2.726115703582764 10.42479610443115 0.4999956786632538 8.198676109313965 0.4999956786632538 5.462395668029785 C 0.4999956786632538 2.726115703582764 2.726115703582764 0.4999956786632538 5.462395668029785 0.4999956786632538 C 8.198676109313965 0.4999956786632538 10.42479610443115 2.726115703582764 10.42479610443115 5.462395668029785 C 10.42479610443115 8.198676109313965 8.198676109313965 10.42479610443115 5.462395668029785 10.42479610443115 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.462395668029785 0.999995231628418 C 3.001815795898438 0.999995231628418 0.999995231628418 3.001815795898438 0.999995231628418 5.462395668029785 C 0.999995231628418 7.922975540161133 3.001815795898438 9.924796104431152 5.462395668029785 9.924796104431152 C 7.922975540161133 9.924796104431152 9.924796104431152 7.922975540161133 9.924796104431152 5.462395668029785 C 9.924796104431152 3.001815795898438 7.922975540161133 0.999995231628418 5.462395668029785 0.999995231628418 M 5.462395668029785 -4.76837158203125e-06 C 8.479195594787598 -4.76837158203125e-06 10.92479610443115 2.445595741271973 10.92479610443115 5.462395668029785 C 10.92479610443115 8.479195594787598 8.479195594787598 10.92479610443115 5.462395668029785 10.92479610443115 C 2.445595741271973 10.92479610443115 -4.76837158203125e-06 8.479195594787598 -4.76837158203125e-06 5.462395668029785 C -4.76837158203125e-06 2.445595741271973 2.445595741271973 -4.76837158203125e-06 5.462395668029785 -4.76837158203125e-06 Z",
    stroke: "none",
    fill: "#4879f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_translate_2792333",
    transform: "translate(832.76 147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15975",
    "data-name": "Group 15975",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13900",
    "data-name": "Path 13900",
    d: "M30.228,109.678a6.381,6.381,0,1,1-6.213,7.841,6.381,6.381,0,1,1,3.338-7.159A6.353,6.353,0,0,1,30.228,109.678ZM23.9,111.771l1.535-.886v.443a2.124,2.124,0,0,1,2.348,2.238,2.255,2.255,0,0,0-2.348-1.352v.443Zm4.261,2.526-1.535.886v-.443a2.124,2.124,0,0,1-2.348-2.238,2.255,2.255,0,0,0,2.348,1.352v-.443Zm-5.292-4.3a5.034,5.034,0,0,1-1.385,3.307,3.353,3.353,0,0,0,2.014,1.017l-.177,1.015a4.358,4.358,0,0,1-2.644-1.389,4.569,4.569,0,0,1-1.709.612l-.177-1.014a3.587,3.587,0,0,0,1.283-.436,5.431,5.431,0,0,1-.664-2.638l1.027-.025a4.483,4.483,0,0,0,.448,2,4.066,4.066,0,0,0,.957-2.443H18.677v-1.04h1.836v-.644H21.77v.644h1.836v1.04Zm6.712,2.719h1.143l2.725,6.692H32.14l-.737-1.932H28.94l-.691,1.932H27.011ZM29.3,116.47h1.714c-.3-.782-.607-1.563-.873-2.356C29.921,114.914,29.6,115.693,29.3,116.47Z",
    transform: "translate(-14.76 -105.44)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.576053fa44c90008001254de93b0acbb.svg";
export { ForwardRef as ReactComponent };